import { Card, Flex } from "@/atoms"
import { CopyButton } from "@/molecules/CopyButton"
import { Heading } from "@/molecules/Heading"

import styles from "./HowToFixCard.module.scss"

import type { HowToFixCardProps } from "./HowToFixCard.types"

export const HowToFixCard = ({ t, onCopy, children }: HowToFixCardProps) => {
  return (
    <Card
      className={styles.container}
      title={
        <Flex
          justify="space-between"
          data-component-id="title-card-fixes-description"
        >
          <Heading level={5} title={t(`general.howToFix`)} />
          {onCopy && (
            <CopyButton size="small" type="secondary" onCopy={onCopy}>
              {t("general.copyFix")}
            </CopyButton>
          )}
        </Flex>
      }
    >
      {children}
    </Card>
  )
}
